/* DUNE · Подписка (sections/dune-signup.liquid).
   1. Показ карточки: таймер, уход курсора вверх, отказ и подписка в localStorage, ярлык до конца визита.
   2. Подсказка в пустом поле печатается по буквам.
   3. Песок: «−10%» собирается из песчинок, порывы её сдувают, курсор раздувает. Палитра футера. */
(() => {
  const root = document.querySelector('[data-dune-signup]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const KEY = 'dune-signup';
  const TAB_KEY = 'dune-signup-tab';
  const DAY = 864e5;
  const card = root.querySelector('.dune-signup__card');
  const tab = root.querySelector('[data-dune-signup-open]');
  const state = root.dataset.state;
  const design = root.dataset.design === 'true';
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  let isOpen = false;
  let timer = null;

  const store = (kind) => {
    try {
      return kind === 'session' ? sessionStorage : localStorage;
    } catch (e) {
      return null;
    }
  };
  const read = () => {
    try {
      return JSON.parse(store().getItem(KEY)) || {};
    } catch (e) {
      return {};
    }
  };
  const write = (patch) => {
    try {
      store().setItem(KEY, JSON.stringify({ ...read(), ...patch }));
    } catch (e) {}
  };
  const setTabFlag = (on) => {
    try {
      on ? store('session').setItem(TAB_KEY, '1') : store('session').removeItem(TAB_KEY);
    } catch (e) {}
  };
  const tabFlag = () => {
    try {
      return store('session').getItem(TAB_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  // Фото в скрытой карточке ленивое и не грузится, пока она не откроется;
  // подгружаем его заранее, как только страница спокойно загрузилась.
  const warm = () => card.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
  if (document.readyState === 'complete') setTimeout(warm, 1500);
  else window.addEventListener('load', () => setTimeout(warm, 1500), { once: true });

  /* ---------- 2. Печатающаяся подсказка ---------- */
  const typer = (() => {
    const el = root.querySelector('[data-dune-signup-type]');
    const input = root.querySelector('.dune-signup__input');
    if (!el || !input) return { start() {}, stop() {} };
    const field = el.parentNode;
    const out = el.querySelector('.dune-signup__type-text');
    let lines = [];
    try {
      lines = JSON.parse(el.dataset.lines).map((s) => s.trim()).filter(Boolean);
    } catch (e) {}
    if (!lines.length) return { start() {}, stop() {} };
    field.classList.add('is-typing');
    let t = null;
    let li = 0;
    let ci = 0;
    let dir = 1;
    let on = false;

    const sync = () => {
      field.classList.toggle('is-filled', input.value !== '');
      field.classList.toggle('is-focus', document.activeElement === input);
    };
    input.addEventListener('input', sync);
    input.addEventListener('focus', sync);
    input.addEventListener('blur', sync);
    sync();

    const tick = () => {
      if (!on) return;
      const line = lines[li];
      ci += dir;
      out.textContent = line.slice(0, ci);
      el.classList.add('is-busy');
      let wait = dir > 0 ? 55 + Math.random() * 70 : 26;
      if (dir > 0 && ci >= line.length) {
        dir = -1;
        wait = 1700;
        el.classList.remove('is-busy');
      } else if (dir < 0 && ci <= 0) {
        dir = 1;
        li = (li + 1) % lines.length;
        wait = 380;
        el.classList.remove('is-busy');
      }
      t = setTimeout(tick, wait);
    };

    return {
      start() {
        if (on) return;
        on = true;
        if (calm) {
          out.textContent = lines[0];
          return;
        }
        li = 0;
        ci = 0;
        dir = 1;
        out.textContent = '';
        t = setTimeout(tick, 700);
      },
      stop() {
        on = false;
        clearTimeout(t);
      }
    };
  })();

  /* ---------- 3. Песок ---------- */
  const sand = (() => {
    const cv = root.querySelector('[data-dune-signup-sand]');
    const media = root.querySelector('[data-dune-signup-media]');
    const fig = root.querySelector('[data-dune-signup-figure]');
    const ctx = cv && cv.getContext && cv.getContext('2d');
    if (!ctx || !media || !fig || !window.requestAnimationFrame) return { start() {}, stop() {} };

    // как в футере: светлый песок + фирменный жёлтый
    const FIG = cv.dataset.color === 'white'
      ? [['#ffffff', 0.45], ['#f1ede4', 0.3], ['#d8d2c4', 0.2], ['#dec400', 0.05]]
      : [['#dec400', 0.7], ['#ead63f', 0.18], ['#f1ede4', 0.1], ['#ffffff', 0.02]];
    const DUST = ['rgba(216,210,196,.75)', 'rgba(199,191,175,.6)', 'rgba(241,237,228,.55)'];
    const gustEvery = Math.max(4, Number(cv.dataset.gust) || 7);

    let W = 0, H = 0, DPR = 1, T = 0, last = 0, raf = 0, running = false, built = false;
    let grains = [], dust = [], gust = null, nextGust = 0;
    const ptr = { x: -1e4, y: -1e4, vx: 0, vy: 0, t: 0 };

    const noise = (x, y) => Math.sin(x * 1.7 + Math.sin(y * 1.3)) * 0.5 + Math.sin(y * 2.1 + x * 0.6) * 0.5;
    const pick = (pal) => {
      let r = Math.random();
      for (let i = 0; i < pal.length; i++) {
        r -= pal[i][1];
        if (r <= 0) return i;
      }
      return 0;
    };

    // точки цифры: рисуем текст тем же шрифтом в невидимый холст и берём закрашенные пиксели
    function targets() {
      const m = media.getBoundingClientRect();
      const r = fig.getBoundingClientRect();
      const cs = getComputedStyle(fig);
      const off = document.createElement('canvas');
      off.width = Math.max(1, Math.ceil(W));
      off.height = Math.max(1, Math.ceil(H));
      const o = off.getContext('2d', { willReadFrequently: true });
      o.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
      if ('letterSpacing' in o) o.letterSpacing = cs.letterSpacing;
      o.fillStyle = '#000';
      o.textBaseline = 'alphabetic';
      const text = fig.textContent.trim();
      const mt = o.measureText(text);
      const asc = mt.actualBoundingBoxAscent || parseFloat(cs.fontSize) * 0.75;
      const desc = mt.actualBoundingBoxDescent || 0;
      const x = r.left - m.left;
      const y = r.top - m.top + (r.height - asc - desc) / 2 + asc;
      o.fillText(text, x, y);
      const data = o.getImageData(0, 0, off.width, off.height).data;
      const gap = 1.6;
      const pts = [];
      for (let yy = 0; yy < off.height; yy += gap) {
        for (let xx = 0; xx < off.width; xx += gap) {
          const i = ((yy | 0) * off.width + (xx | 0)) * 4 + 3;
          if (data[i] > 140) pts.push([xx + (Math.random() - 0.5) * 0.8, yy + (Math.random() - 0.5) * 0.8]);
        }
      }
      return pts;
    }

    function scatter(p) {
      p.x = -10 - Math.random() * W * 0.7;
      p.y = p.ty + (Math.random() - 0.5) * H * 0.7;
      p.vx = 0;
      p.vy = 0;
      p.free = 0;
      p.delay = (p.tx / W) * 0.9 + Math.random() * 0.55;
    }

    function build(fresh) {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = media.clientWidth;
      H = media.clientHeight;
      if (!W || !H) return false;
      cv.width = Math.round(W * DPR);
      cv.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      const pts = targets();
      if (!pts.length) return false;
      grains = pts.map(([tx, ty]) => {
        const p = { tx, ty, c: pick(FIG), s: 0.8 + Math.random() * 0.8, x: tx, y: ty, vx: 0, vy: 0, free: 0, delay: 0 };
        if (fresh && !calm) scatter(p);
        return p;
      });
      dust = [];
      const n = Math.round((W * H) / 900);
      for (let i = 0; i < n; i++) {
        dust.push({ x: Math.random() * W, y: Math.random() * H, z: 0.4 + Math.random() * 0.9, c: (Math.random() * 3) | 0 });
      }
      media.classList.add('has-sand');
      built = true;
      return true;
    }

    function step(dt) {
      T += dt;
      // фон: редкая пыль летит слева направо, в порыв быстрее
      const g = gust ? 1 : 0;
      for (const d of dust) {
        d.x += (26 + g * 140) * d.z * dt;
        d.y += noise(d.x * 0.02, T * 0.6 + d.z * 9) * 8 * dt;
        if (d.x > W + 4) {
          d.x = -4;
          d.y = Math.random() * H;
        }
      }

      // порыв: фронт идёт слева направо и срывает часть песчинок с цифры
      if (!gust && T > nextGust) {
        gust = { x: -30, id: T };
        nextGust = T + gustEvery * (0.8 + Math.random() * 0.5);
      }
      if (gust) {
        gust.x += W * 1.1 * dt;
        if (gust.x > W + 40) gust = null;
      }

      // курсор: скорость сглаживаем, к центру действие сильнее
      ptr.vx *= 0.9;
      ptr.vy *= 0.9;
      const pr = 46;

      for (const p of grains) {
        if (T < p.delay) continue;
        if (gust && p.hit !== gust.id && Math.abs(p.x - gust.x) < 16 && p.free <= 0) {
          p.hit = gust.id;
          if (Math.random() < 0.42) {
            p.free = 0.35 + Math.random() * 0.9;
            p.vx += 140 + Math.random() * 260;
            p.vy += (Math.random() - 0.65) * 140;
          }
        }
        if (fine && ptr.t > 0) {
          const dx = p.x - ptr.x, dy = p.y - ptr.y, d2 = dx * dx + dy * dy;
          if (d2 < pr * pr) {
            const f = 1 - Math.sqrt(d2) / pr;
            p.vx += (ptr.vx * 0.9 + dx * 6) * f * dt * 6;
            p.vy += (ptr.vy * 0.9 + dy * 6) * f * dt * 6;
            p.free = Math.max(p.free, 0.12 * f);
          }
        }

        if (p.free > 0) {
          // в воздухе: несёт ветром, чуть подбрасывает
          p.free -= dt;
          p.vx += (210 - p.vx) * dt * 1.6;
          p.vy += (noise(p.x * 0.03, p.y * 0.03 + T) * 60 - p.vy) * dt * 2;
        } else {
          // пружина к своему месту в цифре + затухающая турбулентность
          const dx = p.tx - p.x, dy = p.ty - p.y;
          const dist = Math.abs(dx) + Math.abs(dy);
          const tb = Math.min(1, dist / 50) * 140;
          p.vx += (dx * 34 - p.vx * 9 + noise(p.y * 0.05, T * 1.3) * tb) * dt;
          p.vy += (dy * 34 - p.vy * 9 + noise(p.x * 0.05, T * 1.1 + 3) * tb) * dt;
        }
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        // сдутые за правый край прилетают обратно слева, как новый песок
        if (p.x > W + 8) {
          p.x = -8 - Math.random() * 30;
          p.y = p.ty + (Math.random() - 0.5) * 60;
          p.vx = 60;
          p.free = 0;
        }
      }
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      for (let ci = 0; ci < DUST.length; ci++) {
        ctx.fillStyle = DUST[ci];
        for (const d of dust) if (d.c === ci) ctx.fillRect(d.x, d.y, 0.6 + d.z * 0.7, 0.6 + d.z * 0.7);
      }
      for (let ci = 0; ci < FIG.length; ci++) {
        ctx.fillStyle = FIG[ci][0];
        for (const p of grains) {
          if (p.c !== ci) continue;
          // быстрые песчинки тянутся короткой чертой
          const sp = p.vx > 120 ? Math.min(7, p.vx * 0.018) : 0;
          ctx.fillRect(p.x - sp, p.y, p.s + sp, p.s);
        }
      }
    }

    function frame(ts) {
      raf = 0;
      if (!running) return;
      const dt = Math.min(0.04, (ts - last) / 1000 || 0.016);
      last = ts;
      if (!document.hidden) {
        step(dt);
        draw();
      }
      raf = requestAnimationFrame(frame);
    }

    media.addEventListener('pointermove', (e) => {
      const m = media.getBoundingClientRect();
      const x = e.clientX - m.left, y = e.clientY - m.top;
      if (ptr.t > 0) {
        ptr.vx = ptr.vx * 0.5 + (x - ptr.x) * 30;
        ptr.vy = ptr.vy * 0.5 + (y - ptr.y) * 30;
      }
      ptr.x = x;
      ptr.y = y;
      ptr.t = 1;
    });
    media.addEventListener('pointerleave', () => {
      ptr.t = 0;
      ptr.x = ptr.y = -1e4;
    });

    let rt = null;
    window.addEventListener('resize', () => {
      clearTimeout(rt);
      rt = setTimeout(() => {
        if (!running) {
          built = false;
          return;
        }
        build(false);
        if (calm) draw();
      }, 200);
    });

    const fontReady = () =>
      document.fonts && document.fonts.load
        ? Promise.race([
            document.fonts.load(`700 ${getComputedStyle(fig).fontSize} Unbounded`),
            new Promise((r) => setTimeout(r, 1500))
          ]).catch(() => {})
        : Promise.resolve();

    return {
      start() {
        if (running) return;
        running = true;
        // ждём, пока карточка раскроется и шрифт цифры загрузится, иначе точки встанут криво
        setTimeout(() => {
          fontReady().then(() => {
            if (!running) return;
            if (!build(true)) return;
            T = 0;
            nextGust = 3.2;
            gust = null;
            if (calm) {
              draw();
              return;
            }
            last = performance.now();
            raf = requestAnimationFrame(frame);
          });
        }, 120);
      },
      stop() {
        running = false;
        if (raf) cancelAnimationFrame(raf);
        raf = 0;
      }
    };
  })();

  /* ---------- 1. Показ ---------- */
  function showTab(on) {
    if (tab) tab.hidden = !on;
  }

  function open(byUser) {
    if (isOpen) return;
    isOpen = true;
    clearTimeout(timer);
    showTab(false);
    root.classList.add('is-open');
    card.setAttribute('aria-hidden', 'false');
    sand.start();
    typer.start();
    // фокус переносим только когда человек сам открыл карточку: иначе она мешала бы листать сайт
    if (byUser) {
      const input = card.querySelector('.dune-signup__input');
      setTimeout(() => (fine && input ? input : card).focus({ preventScroll: true }), 80);
    }
  }

  function close(how) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    card.setAttribute('aria-hidden', 'true');
    sand.stop();
    typer.stop();
    if (design) return;
    if (state === 'success') {
      setTabFlag(false);
      return;
    }
    write({ dismissed: Date.now() });
    if (how === 'min') {
      setTabFlag(true);
      setTimeout(() => showTab(true), 450);
    } else {
      setTabFlag(false);
    }
  }

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-dune-signup-min]')) close('min');
    else if (e.target.closest('[data-dune-signup-close]')) close('dismiss');
    else if (e.target.closest('[data-dune-signup-open]')) open(true);

    const copy = e.target.closest('[data-dune-signup-copy]');
    if (copy) {
      const code = root.querySelector('[data-dune-signup-code]');
      if (!code || !navigator.clipboard) return;
      navigator.clipboard.writeText(code.textContent.trim()).then(() => {
        copy.textContent = copy.dataset.done;
      });
    }
  });

  card.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close('min');
  });

  // Редактор тем: карточка открывается при выборе секции и закрывается, когда её покидают.
  if (design) {
    document.addEventListener('shopify:section:select', (e) => {
      if (e.detail.sectionId === root.dataset.section) open(false);
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      if (e.detail.sectionId === root.dataset.section) close();
    });
    return;
  }

  // Вернулись после отправки формы. Shopify отмечает успехом все формы подписки на странице,
  // поэтому смотрим на якорь: #dune-signup-form — отправили карточку, иначе полосу в футере.
  if ((state === 'success' || state === 'error') && location.hash !== '#dune-signup-form') {
    if (state === 'success') write({ subscribed: Date.now() });
    return;
  }
  // Карточка: убираем ?customer_posted и #якорь, чтобы перезагрузка не открыла её снова,
  // и сразу показываем результат.
  if (state === 'success' || state === 'error') {
    const url = new URL(location.href);
    url.searchParams.delete('customer_posted');
    history.replaceState(history.state, '', url.pathname + url.search);
    if (state === 'success') write({ subscribed: Date.now() });
    open(state === 'error');
    return;
  }

  const saved = read();
  if (saved.subscribed) return;
  if (tabFlag()) {
    showTab(true);
    return;
  }
  const days = Number(root.dataset.days) || 7;
  if (saved.dismissed && Date.now() - saved.dismissed < days * DAY) return;

  // Сама карточка выезжает один раз: после показа на следующих страницах визита стоит ярлык,
  // а следующий раз она выедет через `days` дней, даже если её не закрывали.
  const autoOpen = () => {
    write({ dismissed: Date.now() });
    setTabFlag(true);
    open(false);
  };
  timer = setTimeout(autoOpen, (Number(root.dataset.delay) || 15) * 1000);

  if (root.dataset.exit === 'true' && fine) {
    const armed = Date.now() + 4000;
    const onLeave = (e) => {
      if (e.relatedTarget || e.clientY > 0 || Date.now() < armed) return;
      document.removeEventListener('mouseout', onLeave);
      if (!isOpen) autoOpen();
    };
    document.addEventListener('mouseout', onLeave);
  }
})();
